export const REFERRAL_CODE_KEY = "bh_rcode";
export const COUNTRY_CODE_KEY = "bh_ccode";
export const CART_TOKEN_KEY = "bh_cart_token";
/**
 * 사용자가 **직접 고른 언어**(#5859). Next.js 관례 이름 — 공식 가이드가 언어 선택기에서 이 쿠키를 설정해
 * 자동 판정보다 우선하게 하라고 권한다. 우리는 `localeDetection: false` 라 Next 가 이 쿠키로 스스로
 * 리다이렉트하지 않고, 미들웨어가 직접 읽는다(`resolveTargetLanguage`).
 */
export const LANGUAGE_PREFERENCE_KEY = "NEXT_LOCALE";
